import React, { useEffect, useState } from 'react';

interface ScrollAmbientBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

const ScrollAmbientBackground: React.FC<ScrollAmbientBackgroundProps> = ({ 
  children, 
  className = '' 
}) => {

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = documentHeight > 0 ? scrollTop / documentHeight : 0;
      
      // Smooth the scroll progress for more organic transitions
      const smoothProgress = Math.min(Math.max(scrollPercent, 0), 1);
      
      // Update CSS custom property for ambient background
      document.documentElement.style.setProperty('--scroll-progress', smoothProgress.toString());
    };

    // Initial calculation
    handleScroll();
    
    // Add scroll listener with throttling for performance
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', throttledScroll);
    };
  }, []);

  return (
    <div className={`ambient-background ${className}`}>
      {children}
    </div>
  );
};

export default ScrollAmbientBackground;